import { useEffectiveBetaMode } from "@/hooks/useEffectiveBetaMode";

/**
 * AdminBetaPreviewIndicator — subtle dashed frame around the viewport shown
 * ONLY while an admin has toggled "Vezi cum arată în Beta" on. The bottom
 * pill was removed because the header toggle already makes the state obvious;
 * the frame alone is enough to remind the admin they're seeing fake UI.
 */
const AdminBetaPreviewIndicator = () => {
  const { adminPreviewBeta } = useEffectiveBetaMode();

  if (!adminPreviewBeta) return null;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[60] border-4 border-dashed border-primary/70"
    />
  );
};

export default AdminBetaPreviewIndicator;
